import React from 'react';
import { Phone, Mail, MapPin, Shield } from 'lucide-react';
import { mockData } from '../mockData';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1e3a5f] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <img 
                src={mockData.company.logo} 
                alt="ShieldComply Logo" 
                className="h-20 w-auto object-contain bg-white rounded-md p-2"
              />
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Your trusted partner in emergency management and fire safety compliance across Australia.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li>
                <a href="#services" className="hover:text-red-400 transition-colors">Services</a>
              </li>
              <li>
                <a href="#industries" className="hover:text-red-400 transition-colors">Industries</a>
              </li>
              <li>
                <a href="#why-choose-us" className="hover:text-red-400 transition-colors">Why Choose Us</a>
              </li>
              <li>
                <a href="#contact" className="hover:text-red-400 transition-colors">Contact</a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Our Services</h3>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li className="hover:text-red-400 transition-colors cursor-pointer">Emergency Manuals</li>
              <li className="hover:text-red-400 transition-colors cursor-pointer">Evacuation Diagrams</li>
              <li className="hover:text-red-400 transition-colors cursor-pointer">Training Programs</li>
              <li className="hover:text-red-400 transition-colors cursor-pointer">Fire Safety Services</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Contact Us</h3>
            <ul className="space-y-3 text-gray-300 text-sm">
              <li className="flex items-start gap-2">
                <Phone size={16} className="mt-0.5 flex-shrink-0 text-red-400" />
                <a href={`tel:${mockData.company.phone}`} className="hover:text-red-400 transition-colors">
                  {mockData.company.phone}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={16} className="mt-0.5 flex-shrink-0 text-red-400" />
                <a href={`mailto:${mockData.company.email}`} className="hover:text-red-400 transition-colors">
                  {mockData.company.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="mt-0.5 flex-shrink-0 text-red-400" />
                <div>
                  <div className="font-semibold text-white">Based: {mockData.company.address}</div>
                  <div className="text-xs mt-1">{mockData.company.serviceAreas}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>&copy; {currentYear} ShieldComply. All rights reserved.</p>
            <div className="flex items-center gap-2">
              <Shield size={16} className="text-red-400" />
              <span>Your Emergency Compliance Partner</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
